import React, { useEffect } from "react";
import { convertirCodigoAMeses, descargarDocPasandoBase64Generico, obtenerToken, obtenerUsuario, traducirPagina } from "../../librerias/funciones";
import { Select } from "antd";
import { CloseOutlined, CloudDownloadOutlined, DownOutlined, EyeInvisibleOutlined, EyeOutlined, ReloadOutlined, SearchOutlined, UpOutlined } from "@ant-design/icons";
import '../../styles/consumo.css'
import { GetCSVEnAPI, ObtenerFiltrosEstadisticasConsumosEnAPI, PostCSVEnAPI } from "../../action/actionCreatorsRequests";

const { Option } = Select;
const FiltersConsumos = ({ hayRegistros = true,
    eventPais = () => { }, eventPeriodo = () => { }, eventEntreFechas = () => { },
    eventSelect1 = () => { }, eventSelect2 = () => { }, eventActualizarTabla = () => { },
    eventSelectSocio = () => { }, ObtenerConsumos = () => { }, EstadisticasConsumosTotales = () => { },
    eventUnidades = () => { }, eventTextoFiltro = () => { },
    children, REGISTROS_TABLA = [],CABECERAS=[]
}) => {

    const [initFilter, setInitFilter] = React.useState({})
    const [registroSocios, setRegistroSocios] = React.useState([]);

    const acrivarFiltro1 = (ID) => {
        initFilter.FILTRO1.map((registro) => {
            registro.SELECCIONADO = registro.ID === ID ? true : false
        })

        initFilter.FILTRO2.map((registro) => {
            registro.SELECCIONADO = registro.ID_PADRE === ID && registro.ID === 0 ? true : false
        })

        setInitFilter({ ...initFilter })
    }

    const acrivarFiltro2 = (ID_PADRE, ID) => {
        initFilter.FILTRO2.map((registro) => {
            registro.SELECCIONADO = registro.ID_PADRE === ID_PADRE && registro.ID === ID ? true : false
        })
        setInitFilter({ ...initFilter })
    }



    const seleccionarRegistro = (arrayOriginal, param, ID) => {
        let expresion = `arrayOriginal.${param}`
        let convertir = eval(expresion)

        convertir.map((registro) => {
            registro.SELECCIONADO = registro.ID === ID ? true : false
        })

        setInitFilter({ ...arrayOriginal })
    }



    const ObtenerFiltrosEstadisticasConsumos = async () => {
        setInitFilter({});

        let registro = await ObtenerFiltrosEstadisticasConsumosEnAPI()
        const { OK } = registro
        if (registro !== undefined && !OK) {
            registro.TXT_FILTRO = ""
            registro.ACTIVE_MENU = 0
            registro.ID_SOCIO = null


            setInitFilter(registro)
        }
        return registro

    }






    const registroSeleccionado = (registros, textoPorDefecto) => {
        const registro = registros === undefined ? undefined : registros.find((registro) => registro.SELECCIONADO)

        const { DESCRIPCION } = registro === undefined ? { DESCRIPCION: textoPorDefecto } : registro
        return DESCRIPCION

    }


    const seleccionadoActual = (registros) => {
        let REGISTRO = registros.find((registro) => registro.SELECCIONADO)
        return REGISTRO === undefined ? { ID: null, DESCRIPCION: null } : REGISTRO
    }


    const filtrarConsumos = (REGISTROS, SELECCIONADO) => {
        return REGISTROS.filter((registro) => registro.ID_PADRE === SELECCIONADO)

    }
    const textoFiltroBuscador = (FILTRO_INICIAL) => {
        let ID_FILTRO = seleccionadoActual(FILTRO_INICIAL).ID
        let TRADUCCION = ""

        switch (ID_FILTRO) {
            case 0:
                TRADUCCION = traducirPagina("Filtro_proveedor")
                break;
            case 1:
                TRADUCCION = traducirPagina("filtro_familia")
                break;
            case 2:
                TRADUCCION = traducirPagina("filtro_subfamilia")
                break;
            case 3:
                TRADUCCION = traducirPagina("filtro_marca")
                break;

        }

        return TRADUCCION
    }



    const crearAnyos = (ANYO_MAXIMO, NUM_ANYOS, ANYO_SELECCIONADO) => {
        let ANYOS = [];


        let NUMERO = NUM_ANYOS;
        let ULTIMO_ANYO = ANYO_MAXIMO;
        if (NUMERO !== undefined && NUMERO !== null) {
            while (NUMERO > 0) {
                NUMERO = NUMERO - 1
                ANYOS.push({ ID: ULTIMO_ANYO, DESCRIPCION: ULTIMO_ANYO, SELECCIONADO: ULTIMO_ANYO === ANYO_SELECCIONADO ? true : false })
                ULTIMO_ANYO = ULTIMO_ANYO - 1

            }
        }

        return ANYOS;
    }



    const descargarDocumento = async (registros,CABECERAS) => {
        const result = await PostCSVEnAPI(registros,CABECERAS)
        

        if (result !== undefined && result.CSV !== null && result.CSV !== "") {
            descargarDocPasandoBase64Generico(result.CSV, "csv")
        }
    }



    useEffect(() => {
        if (obtenerToken() !== undefined) {

            ObtenerFiltrosEstadisticasConsumos().then((RESULTADO) => {
                const { ANYO_MAXIMO, NUM_ANYOS, SOCIOS, ANYO_SEL } = obtenerUsuario();
                let ANYO_SELECCIONADO = parseInt(ANYO_SEL)
                const { DESDE, HASTA } = RESULTADO !== undefined && !RESULTADO.OK ? RESULTADO.ENTRE_MESES : { DESDE: 0, HASTA: 12 }


                let condicion = SOCIOS !== undefined && SOCIOS !== null && SOCIOS.length > 1
                if (condicion) {
                    RESULTADO.ID_SOCIO = null
                    setRegistroSocios(SOCIOS)

                } else {
                    RESULTADO.ID_SOCIO = SOCIOS[0].ID_SOCIO
                }


                //generar Años
                const ANYOS_GENERADOS = crearAnyos(ANYO_MAXIMO, NUM_ANYOS, ANYO_SELECCIONADO)
                RESULTADO.PERIODO = ANYOS_GENERADOS
                setInitFilter({ ...RESULTADO })



                ObtenerConsumos(0, 0, DESDE, HASTA, seleccionadoActual(RESULTADO.PERIODO).ID, seleccionadoActual(RESULTADO.PAISES).ID, RESULTADO.ID_SOCIO)
                EstadisticasConsumosTotales(seleccionadoActual(RESULTADO.PERIODO).ID, seleccionadoActual(RESULTADO.PAISES).ID, RESULTADO.ID_SOCIO, DESDE, HASTA)


            })
        }

    }, [])

    return (
        <>
            <div className='mantenimiento_item1' style={{ gap: '10px 0px', paddingBottom: '10px', justifyContent: 'space-between' }}>

                {
                    Object.keys(initFilter).length > 0 ?
                        <>
                            <ul className="nested-dropdowns mantenimiento_item1" style={{ gap: '10px 0px' }}>
                                <li className={initFilter.ACTIVE_MENU === 1 && "nested-dropdowns_active"}
                                    onClick={() => {
                                        initFilter.ACTIVE_MENU = initFilter.ACTIVE_MENU === 1 ? 0 : 1;
                                        setInitFilter({ ...initFilter })
                                    }}
                                    style={{ backgroundColor: 'var(--amarillo-serca)', color: 'var(--azul-claro-serca)' }}

                                >

                                    <div className={`nested-dropdowns__item`}  >
                                        {registroSeleccionado(initFilter.PAISES, traducirPagina("Pais"))}

                                        {initFilter.ACTIVE_MENU === 1 ?
                                            <UpOutlined></UpOutlined>
                                            :
                                            <DownOutlined></DownOutlined>

                                        }
                                    </div>

                                    <ul className={initFilter.ACTIVE_MENU === 1 && "open_dropdowns"} style={{ width: 'auto' }}>
                                        {initFilter.PAISES.map((registro) =>
                                            <li key={registro.ID} onClick={() => {
                                                seleccionarRegistro(initFilter, "PAISES", registro.ID)

                                                eventPais(registro, initFilter)
                                            }
                                            }>{registro.DESCRIPCION}</li>
                                        )}
                                    </ul>

                                </li>

                                <li className={initFilter.ACTIVE_MENU === 2 && "nested-dropdowns_active"}
                                    onClick={() => { initFilter.ACTIVE_MENU = initFilter.ACTIVE_MENU === 2 ? 0 : 2; setInitFilter({ ...initFilter }) }}
                                >
                                    <div className={`nested-dropdowns__item`} >
                                        {registroSeleccionado(initFilter.PERIODO, traducirPagina("Periodo_activo"))}


                                        {initFilter.ACTIVE_MENU === 2 ?
                                            <UpOutlined></UpOutlined>
                                            :
                                            <DownOutlined></DownOutlined>
                                        }
                                    </div>

                                    <ul className={initFilter.ACTIVE_MENU === 2 && "open_dropdowns"}>
                                        {initFilter.PERIODO.map((registro, i) =>
                                            <li key={i} onClick={() => {
                                                seleccionarRegistro(initFilter, "PERIODO", registro.ID)

                                                eventPeriodo(registro, initFilter)
                                            }}>{registro.DESCRIPCION}</li>
                                        )}
                                    </ul>
                                </li>

                                <li className={initFilter.ACTIVE_MENU === 3 && "nested-dropdowns_active"}>
                                    <div className={`nested-dropdowns__item`} onClick={() => { initFilter.ACTIVE_MENU = initFilter.ACTIVE_MENU === 3 ? 0 : 3; setInitFilter({ ...initFilter }) }}>
                                        {`${traducirPagina("txt_de")} ${traducirPagina(convertirCodigoAMeses(initFilter.ENTRE_MESES.DESDE))} ${traducirPagina("txt_a").toUpperCase()} ${traducirPagina(initFilter.ENTRE_MESES.HASTA !== 0 && convertirCodigoAMeses(initFilter.ENTRE_MESES.HASTA))}`}

                                        {initFilter.ACTIVE_MENU === 3 ?
                                            <UpOutlined></UpOutlined>
                                            :
                                            <DownOutlined></DownOutlined>

                                        }
                                    </div>


                                    <ul className={initFilter.ACTIVE_MENU === 3 && "open_dropdowns"} >
                                        <div className="cp_fechas">

                                            <div className="containerFechas">
                                                <div className="containerFechas_item1">
                                                    <div className="titulo_fecha">{traducirPagina("Desde").toUpperCase()}</div>
                                                    <div className="grupo_fecha">
                                                        {initFilter.INICIAL_MES.map((registro, i) =>
                                                            <button key={i}
                                                                className={`${registro.ID === initFilter.ENTRE_MESES.DESDE && "active_interval"} grupo_fecha_item`}
                                                                onClick={() => {
                                                                    initFilter.ENTRE_MESES.DESDE = registro.ID
                                                                    initFilter.ENTRE_MESES.HASTA = 0
                                                                    setInitFilter({ ...initFilter })
                                                                }}
                                                            >{registro.DESCRIPCION}</button>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="containerFechas_item2">
                                                    <div className="titulo_fecha">{traducirPagina("Hasta").toUpperCase()}</div>
                                                    <div className="grupo_fecha" >
                                                        {initFilter.INICIAL_MES.map((registro, i) =>
                                                            <button key={i}
                                                                disabled={registro.ID < initFilter.ENTRE_MESES.DESDE}
                                                                className={`${registro.ID < initFilter.ENTRE_MESES.DESDE && "mes_desactivado"} ${registro.ID === initFilter.ENTRE_MESES.HASTA && "active_interval"} grupo_fecha_item`}
                                                                onClick={() => {
                                                                    initFilter.ENTRE_MESES.HASTA = registro.ID
                                                                    setInitFilter({ ...initFilter })
                                                                }}
                                                            >{registro.DESCRIPCION}</button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="container_btn_fecha">
                                                <button className={`btn_aceptar_fechas ${initFilter.ENTRE_MESES.DESDE === 0 || initFilter.ENTRE_MESES.HASTA === 0 && "btn_fecha_desactivado"}`}
                                                    onClick={() => {
                                                        initFilter.ACTIVE_MENU = 0;
                                                        setInitFilter({ ...initFilter })

                                                        eventEntreFechas(initFilter)
                                                    }}

                                                >{traducirPagina("Aceptar")}</button>
                                            </div>

                                        </div>
                                    </ul>

                                </li>

                                <li className={initFilter.ACTIVE_MENU === 4 && "nested-dropdowns_active"}
                                    onClick={() => { initFilter.ACTIVE_MENU = initFilter.ACTIVE_MENU === 4 ? 0 : 4; setInitFilter({ ...initFilter }) }}
                                >

                                    <div className={`nested-dropdowns__item`}>
                                        {seleccionadoActual(initFilter.FILTRO1).DESCRIPCION}
                                        {initFilter.ACTIVE_MENU === 4 ?
                                            <UpOutlined></UpOutlined>
                                            :
                                            <DownOutlined></DownOutlined>

                                        }
                                    </div>

                                    <ul className={initFilter.ACTIVE_MENU === 4 && "open_dropdowns custom_menu"} >
                                        {initFilter.FILTRO1.map((registro, i) =>
                                            <li key={registro.ID} onClick={() => {
                                                acrivarFiltro1(registro.ID)

                                                eventSelect1(registro, initFilter)
                                            }
                                            }>{registro.DESCRIPCION}</li>
                                        )}
                                    </ul>


                                </li>

                                <li className={initFilter.ACTIVE_MENU === 5 && "nested-dropdowns_active"}
                                    onClick={() => { initFilter.ACTIVE_MENU = initFilter.ACTIVE_MENU === 5 ? 0 : 5; setInitFilter({ ...initFilter }) }}
                                >

                                    <div className={`nested-dropdowns__item`}>
                                        {seleccionadoActual(initFilter.FILTRO2).DESCRIPCION}

                                        {initFilter.ACTIVE_MENU === 5 ?
                                            <UpOutlined></UpOutlined>
                                            :
                                            <DownOutlined></DownOutlined>
                                        }
                                    </div>


                                    <ul className={initFilter.ACTIVE_MENU === 5 && "open_dropdowns custom_menu"} style={{ width: 'auto' }}>
                                        {filtrarConsumos(initFilter.FILTRO2, initFilter.FILTRO1.find((registro) => registro.SELECCIONADO).ID).map((registro, i) =>
                                            <li key={registro.ID} onClick={() => {
                                                acrivarFiltro2(registro.ID_PADRE, registro.ID)

                                                eventSelect2(registro, initFilter)
                                            }}>{registro.DESCRIPCION}</li>
                                        )}
                                    </ul>
                                </li>



                                <li className={REGISTROS_TABLA.length > 0 ? "" : "disable_button"}
                                    onClick={() => {
                                        descargarDocumento(REGISTROS_TABLA,CABECERAS)
                                    }}
                                >
                                    <CloudDownloadOutlined></CloudDownloadOutlined>
                                </li>





                                <li className={initFilter.ACTIVE_MENU === 6 && "nested-dropdowns_active"}
                                    onClick={() => {
                                        initFilter.ACTIVE_MENU = initFilter.ACTIVE_MENU === 6 ? 0 : 6;
                                        initFilter.ACTIVAR_UNIDADES = !initFilter.ACTIVAR_UNIDADES

                                        eventUnidades(initFilter)


                                        setInitFilter({ ...initFilter })
                                    }}
                                >
                                    <div className={`nested-dropdowns__item icono_grande`}>

                                        {initFilter.ACTIVAR_UNIDADES ?
                                            <EyeInvisibleOutlined></EyeInvisibleOutlined>
                                            :
                                            <EyeOutlined></EyeOutlined>
                                        }

                                        {traducirPagina("Unidades")}
                                    </div>
                                </li>

                                <li
                                    onClick={() => { eventActualizarTabla(initFilter) }}
                                >
                                    <div className={`nested-dropdowns__item icono_grande`}>
                                        <ReloadOutlined></ReloadOutlined>

                                        {"Actualizar tabla"}
                                    </div>
                                </li>

                            </ul>



                            <div style={{ display: 'flex', gap: '10px' }}>
                                {
                                    registroSocios !== null && registroSocios.length > 0 ?
                                        <Select
                                            showSearch
                                            allowClear={true}
                                            value={initFilter.ID_SOCIO === null || initFilter.ID_SOCIO === 0 ? traducirPagina("Seleccione_socio") : initFilter.ID_SOCIO}
                                            style={{ width: '250px' }}
                                            className="select_consumo"
                                            size="large"
                                            placeholder={traducirPagina("Seleccione_socio")}
                                            onChange={(e) => {
                                                let registroSeleccionado = e === undefined || e === null ? null : e
                                                initFilter.ID_SOCIO = registroSeleccionado
                                                setInitFilter({ ...initFilter })

                                                eventSelectSocio(e, initFilter)

                                            }}
                                            filterOption={(input, option) =>
                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {registroSocios.length > 0 ?
                                                registroSocios.map((registro) =>
                                                    <Option key={registro.ID_SOCIO} value={registro.ID_SOCIO}>{registro.NOMBRE_SOCIO}</Option>
                                                )
                                                :
                                                null
                                            }
                                        </Select>
                                        :
                                        null

                                }

                                <div className="grid-container" style={{ backgroundColor: '#eee', padding: '0px', height: '45px' }}>
                                    <div className="grid-item">
                                        <input className="form-control eliminarFoco " type="text" aria-label="Search" placeholder={textoFiltroBuscador(initFilter.FILTRO1)} style={{ backgroundColor: "transparent", border: '0px', height: '100%', color: '#000' }} name="txtInputCliente" autoComplete="off"
                                            onChange={(e) => {
                                                initFilter.TXT_FILTRO = e.target.value;
                                                setInitFilter({ ...initFilter })
                                                eventTextoFiltro(initFilter)
                                            }}
                                            value={initFilter.TXT_FILTRO} />
                                    </div>

                                    <div className="grid-item">
                                        <button style={{ visibility: initFilter.TXT_FILTRO.trim() === "" ? 'hidden' : 'visible' }} className="btn-matriculav2 btnEliminarBuscador" onClick={(e) => {
                                            initFilter.TXT_FILTRO = ""; setInitFilter({ ...initFilter })
                                            eventTextoFiltro(initFilter)

                                        }}>  <CloseOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </button>
                                    </div>


                                    <div className="grid-item" >
                                        <button className="btn_buscador_tarifa">  <SearchOutlined style={{ fontSize: '20px' }} /> {traducirPagina("Buscar")} </button>
                                    </div>
                                </div>

                            </div>


                        </>
                        :
                        null
                }
            </div>


        </>
    )
}

export default FiltersConsumos;